import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { UserReadableError } from '../../../api/errors/user-readable.error';
import { FeatureFlagsService } from '../../../services/feature-flags.service';
import { UsersService } from '../../users/services/users.service';
import { Router } from '@angular/router';
import { ToastService } from '../../../../common-modules/services/toast.service';
import { HttpClient } from '@angular/common/http';
import { SecurityaddonsService } from '../../securityaddons/services/securityaddons.service';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
    providedIn: 'root',
})
export class TermsAndConditionsService {
    public constructor(
        private authService: AuthService,
        private featureFlagService: FeatureFlagsService,
        private userService: UsersService,
        private router: Router,
        private toastService: ToastService,
        private http: HttpClient,
        private securityAddonsService: SecurityaddonsService,
        private dialog: MatDialog,
    ) {}

    public get SubmitConfirmTitle(): string {
        return $localize`Terms and Conditions`;
    }

    public get SubmitConfirmOptionalMessage(): string {
        const link =
            '<a href="mailto: cst@bitdefender.com" class="blue-hover-underlined-link text-ellipsis vertical-align-baseline">us</a>';
        return $localize`If you encounter any difficulty, please contact ${link}.`;
    }

    public SubmitConfirmMessage(url: string): string {
        const link = '<a href="' + url + '" target="_blank" class="blue-hover-underlined-link text-ellipsis">Terms and Conditions</a>';
        return $localize`Please read and accept the ${link} in order to continue to the MDR Portal.`;
    }

    public onCreateSuccess(userId: string, showToast = true, extraConfig?: any): void {
        this.userService.acceptTermsAndConditions(userId).subscribe({
            next: () => {
                // TODO - temporary fix
                localStorage.setItem('acceptedTC', 'true');
                window.location.href = '/';

                // if (
                //     (this.securityAddonsService.breachWarrantyIntegration &&
                //         this.securityAddonsService.breachWarrantyIntegration.accepted) ||
                //     !this.securityAddonsService.breachWarrantyIntegration
                // ) {
                //     localStorage.setItem('acceptedTC', 'true');
                //     window.location.href = '/';
                // } else {
                //     this.dialog.open(TcDialogComponent, {
                //         width: '535px',
                //         data: {
                //             ...extraConfig,
                //             disableDialogClose: true,
                //         },
                //         disableClose: true,
                //     });
                // }
            },
            error: (error: UserReadableError) => {
                if (
                    this.securityAddonsService.breachWarrantyIntegration?.accepted ||
                    !this.securityAddonsService.breachWarrantyIntegration
                ) {
                    this.router.navigate(['/intro']);
                }
            },
        });

        if (showToast) {
            this.toastService.showSuccess($localize`Terms and Conditions accepted.`, {
                duration: 5000,
            });
        }
    }

    public onCreateFail(userId: string): void {
        this.authService.logout();
    }

    public SubmitSecondConfirmMessage(url: string): string {
        const link = '<a href="' + url + '" target="_blank" class="blue-hover-underlined-link text-ellipsis">Terms and Conditions</a>';
        return $localize`Please read and accept the ${link} to proceed with your Breach Warranty add on.`;
    }

    public acceptBreachWarrantyInTC(gz_id: string) {
        return this.http.post(`/v2/integrations/breach-warranty/${gz_id}/accept`, {});
    }
}
